var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 321.509,
    height: 70,
    viewBox: "0 0 321.509 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ment.svg",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_248",
    "data-name": "\\uD328\\uC2A4 248",
    d: "M51.964,0V70h59.294V50.811H74.413V43.42h33.168V26.581H74.413V19.188h36.845V0Z",
    transform: "translate(53 0)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_249",
    "data-name": "\\uD328\\uC2A4 249",
    d: "M63.369,0,46.982,45.819,30.6,0H0V70H21.88V32.96L36.657,70H57.023L71.988,32.435V70H93.775V0Z",
    transform: "translate(0 0)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_250",
    "data-name": "\\uD328\\uC2A4 250",
    d: "M136.252,0V39.16h-.19L112.761,0h-26.9V70H107.74V28.195h.1L132.749,70h25.286V0Z",
    transform: "translate(87.943 0)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_251",
    "data-name": "\\uD328\\uC2A4 251",
    d: "M125.516,0V21.441h22.639V70h22.451V21.441h22.54V0Z",
    transform: "translate(128.363 0)",
    fill: "#1a1818"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentM);
export default __webpack_public_path__ + "static/media/ment_m.53e78c0411fff6217a58c688c0a91951.svg";
export { ForwardRef as ReactComponent };